/* eslint-disable import/no-cycle */

import { Box, theme, Stack, HStack, Text } from '@chakra-ui/core';
import React from 'react';
import { MdOutlineCheckBoxOutlineBlank, MdOutlineCircle } from 'react-icons/md';
import { FormFieldT } from '../../types';
import FollowUpPreview from './FollowUpPreview';
import { FORM_COMPONENT_BASIC_INPUT_TYPE } from '../../schemas/formComponentInputTypeSchema';

// eslint-disable-next-line import/no-default-export
export default function ElementPreview({ schema, language }: { schema: FormFieldT; language: string }): JSX.Element {
  return (
    <Box
      borderRadius={theme.radii.md}
      fontSize={theme.fontSizes.sm}
      paddingLeft={2}
      sx={{
        span: {
          fontWeight: 'bold',
        },
      }}
    >
      <Text fontWeight="bold" fontSize="xs">
        {schema?.label?.[language]}
      </Text>
      <Text fontSize="xs" dangerouslySetInnerHTML={{ __html: schema?.text?.[language] ?? '' }} />
      <Box marginTop={1}>
        <Stack spacing={0.2}>
          {schema?.optionList?.map((option) => (
            <Stack spacing={1} key={option.id}>
              <HStack spacing={1} align={FORM_COMPONENT_BASIC_INPUT_TYPE.yesNo === schema.inputType ? 'flex-start' : 'center'}>
                {FORM_COMPONENT_BASIC_INPUT_TYPE.checkbox === schema.inputType && <MdOutlineCheckBoxOutlineBlank color="blue" />}
                {FORM_COMPONENT_BASIC_INPUT_TYPE.radio === schema.inputType && <MdOutlineCircle color="blue" />}
                {FORM_COMPONENT_BASIC_INPUT_TYPE.yesNo === schema.inputType && (
                  <>
                    <Box
                      border="1px solid blue"
                      lineHeight={1}
                      fontSize="xs"
                      fontWeight="bold"
                      paddingX={1}
                      paddingY={1}
                      borderRadius={theme.radii.md}
                    >
                      {option.key}
                    </Box>
                    <FollowUpPreview paddingLeft={1} key={option.id} optionId={option.id} schema={schema} language={language} />
                  </>
                )}
                {FORM_COMPONENT_BASIC_INPUT_TYPE.yesNo !== schema.inputType && (
                  <Text fontSize="xs" key={option.id} dangerouslySetInnerHTML={{ __html: option.text?.[language] ?? '' }} />
                )}
              </HStack>
              {FORM_COMPONENT_BASIC_INPUT_TYPE.yesNo !== schema.inputType && (
                <FollowUpPreview key={option.id} optionId={option.id} schema={schema} language={language} />
              )}
            </Stack>
          ))}
        </Stack>
      </Box>
    </Box>
  );
}
